import { render, staticRenderFns } from "./test_garden.vue?vue&type=template&id=63ec646a&scoped=true&"
import script from "./test_garden.vue?vue&type=script&lang=js&"
export * from "./test_garden.vue?vue&type=script&lang=js&"
import style0 from "./test_garden.vue?vue&type=style&index=0&id=63ec646a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec646a",
  null
  
)

export default component.exports